import { container } from "tsyringe";
import { VuexModule, Action, getModule, Module } from "vuex-module-decorators";
import { OperationalAreaPresenter } from "@/app/ui/presenters/OperationalAreaPresenter";
import {
  UrsaCodeList,
  UrsaCodeListRequest
} from "@/domain/entities/OperationalArea";
import store from "@/store";
import { OperationalAreaComponent } from "@/app/infrastructures/dependencies/modules/OperationalAreaComponent";

OperationalAreaComponent.init();
@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "operational-area"
})
class OperationaAreaStore extends VuexModule {
  @Action
  public getUrsaCodeList(params: UrsaCodeListRequest): Promise<UrsaCodeList> {
    const presenter = container.resolve(OperationalAreaPresenter);
    return presenter.getUrsaCodeList(params);
  }

  @Action
  getUrsaDetail(ursaCode = "") {
    const presenters = container.resolve(OperationalAreaPresenter);
    return presenters.getUrsaDetail(ursaCode);
  }

  @Action
  updateUrsaStatus(payload: {ursaCode: string, status: boolean}) {
    const presenters = container.resolve(OperationalAreaPresenter);
    return presenters.updateUrsaStatus(payload.ursaCode, payload.status);
  }
}

export const OperationalAreaController = getModule(OperationaAreaStore);
